import dayjs, { Dayjs } from "dayjs"

import { Education } from "@/types/getAbout"

export interface EducationDuration {
  durationMonths: number
  durationYears: number
  endDate: Dayjs
  startDate: Dayjs
}

export function getEducationDuration(
  education: Education,
  today = dayjs()
): EducationDuration {
  const startDate = dayjs(education.start_date)
  const endDate = dayjs(education.end_date == null ? today : education.end_date)
  const totalMonths = endDate.diff(startDate, "month")

  return {
    durationMonths: totalMonths % 12,
    durationYears: Math.floor(totalMonths / 12),
    endDate,
    startDate,
  }
}
